import { useMemo } from "react";
import type { PackOverview } from "../../types/state";
import { LabelColors } from "../types";
import { isFreePricingType, isOtherPricingType } from "../../utils/packUtils";

export interface PackLabel {
  name: string;
  color: string;
}

export const usePackLabel = (item: PackOverview): PackLabel | undefined => {
  const { isArchived, isTrial, isExpired, packPricingTypeId, isPurchased } = item;

  return useMemo(() => {
    if (isArchived) {
      return { name: "Archived", color: LabelColors.ARCHIVED };
    }

    if (isOtherPricingType(packPricingTypeId)) {
      return undefined;
    }

    if (isTrial) {
      return isExpired
        ? { name: "Trial Ended", color: LabelColors.EXPIRED }
        : { name: "Trial Started", color: LabelColors.TRIAL_STARTED };
    }

    if (isFreePricingType(packPricingTypeId) && isPurchased) {
      return isExpired
        ? { name: "Free • Expired", color: LabelColors.EXPIRED }
        : { name: "Free • Added", color: LabelColors.FREE };
    }

    if (isFreePricingType(packPricingTypeId) && !isExpired && !isTrial && !isPurchased) {
      return { name: "Free", color: LabelColors.FREE };
    }

    if (isExpired) {
      return { name: "Expired", color: LabelColors.EXPIRED };
    }

    if (isPurchased) {
      return { name: "Purchased", color: LabelColors.PURCHASED };
    }

    return undefined;
  }, [isArchived, packPricingTypeId, isExpired, isTrial, isPurchased]);
};
